interface Dimensions {
  height: string;
  width: string;
}

interface AspectRatio {
  aspectRatio: string;
}

export type AspectRatioDimensions = Dimensions & AspectRatio;
export type OptionalAspectRatioDimensions = Partial<AspectRatioDimensions>;

const greatestCommonDivisor = (a: number, b: number): number => {
  return b ? greatestCommonDivisor(b, a % b) : a;
};

export const calculateAspectRatio = (args: Dimensions): string => {
  const { height, width } = args;
  const parsedHeight = parseInt(height);
  const parsedWidth = parseInt(width);
  const gcd = greatestCommonDivisor(parsedWidth, parsedHeight);

  return `${parsedWidth / gcd}:${parsedHeight / gcd}`;
};

export const calculateRatioDimensions = (args: OptionalAspectRatioDimensions): OptionalAspectRatioDimensions => {
  const { aspectRatio, height, width } = args;

  if (height && width && !aspectRatio) {
    return { aspectRatio: calculateAspectRatio({ height, width }) };
  }

  const parsedHeight = typeof height === 'string' ? parseInt(height) : height;
  const parsedWidth = typeof width === 'string' ? parseInt(width) : width;

  if (aspectRatio && (height || width)) {
    const [aspectWidth, aspectHeight] = aspectRatio.split(':');
    const parsedAspectWidth = parseInt(aspectWidth);
    const parsedAspectHeight = parseInt(aspectHeight);
    const ratio = parsedHeight ? parsedAspectWidth / parsedAspectHeight : parsedAspectHeight / parsedAspectWidth;

    return {
      aspectRatio,
      height: `${Math.round((parsedWidth ? parsedWidth * ratio : parsedHeight) || 0)}px`,
      width: `${Math.round((parsedHeight ? parsedHeight * ratio : parsedWidth) || 0)}px`,
    };
  }

  return args;
};
